import { createAsyncThunk } from "@reduxjs/toolkit";
import { Promotion } from "./promotionTypes";
import employeeServiceApiInstance from '../../../config/employeeApiConfig';

export const createPromotion = createAsyncThunk(
    'promotion/createPromotion',
    async (formData : any ,  {rejectWithValue}) =>{
        try {
           const response = await employeeServiceApiInstance.post('/promotion', formData);
          return response.data;
        } catch (error : any) {
            return rejectWithValue(error.response?.data || 'Failed to create Promotion');
        }
    }
)
export const UpdatePromotion = createAsyncThunk<any , {PromotionId: number; data: any}, { rejectValue: string }>(
  'Promotion/updatePromotion',
  async ({PromotionId , data}: {PromotionId : Number; data: Partial<any>}, { rejectWithValue }) => {
    try {  
      const response = await employeeServiceApiInstance.put(`/promotion/${PromotionId}`, data)
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create termination');
    }
  }
); 


export const fetchAllPromotion = createAsyncThunk(
    'promotion/fetchAllPromotion',
    async (_, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.get('/promotion');
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to fetch Promotion Details');
      }
    }
  );


  export const deletepromotion = createAsyncThunk(
    'promotion/deletepromotion',
    async (promotionId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/promotion/${promotionId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete promotion');
        }
    }
);

export const fetchpromotionById = createAsyncThunk(
  'promotion/fetchById',
  async (promotionId: number, { rejectWithValue }) => {
      try {
          const response = await employeeServiceApiInstance.get(`/promotion/${promotionId}`);
          return response.data;
      } catch (error: any) {
          return rejectWithValue(error.response?.data || 'Failed to fetch promotion');
      }
  }
);

